import {AdminBookmarkCardSkeleton, AdminBookmarkFolderCardSkeleton} from '../cards';
import AdminBookmarksCardGridItem from '../AdminBookmarksCardGridItem';

const FOLDERS_AND_BOOKMARKS_MOCK = [...new Array(6)].map((_, index) => ({
  key: index,
  __typename: index < 2 ? 'Folder' : 'Bookmark',
}));

const AdminBookmarksCardListSkeleton = () => {
  return <>
    {FOLDERS_AND_BOOKMARKS_MOCK.map(mock => (
      <AdminBookmarksCardGridItem key={mock.key}>
        {mock.__typename === 'Folder'
        ? <AdminBookmarkFolderCardSkeleton />
        : <AdminBookmarkCardSkeleton />}
      </AdminBookmarksCardGridItem>
    ))}
  </>
}

export default AdminBookmarksCardListSkeleton;